module.exports = __webpack_public_path__ + "static/media/WBN_plus.67f1f4ec.svg";